import { Avatar, Space, Table } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

import { TableFilter } from 'shared/ui/TableFilter';

import {
    FinanceFilters,
    FinanceTableProps,
} from '../service/finance.interface';
import { currencyFormat } from '../utils/chartOptions';

type Props = {
    readonly source: FinanceTableProps[];
    readonly tableFilters: FinanceFilters;
    readonly onFiltersUpdate: (update: Partial<FinanceFilters>) => void;
    readonly loading: boolean;
};

export const FinanceTable = ({
    source,
    tableFilters,
    onFiltersUpdate,
    loading,
}: Props) => {
    return (
        <Table<FinanceTableProps>
            loading={loading}
            dataSource={source}
            rowKey={payment => payment.id}
            pagination={{
                total: source?.length,
                showTotal: () => `Платежей: ${source?.length}`,
            }}
        >
            <Table.Column
                title={'Дата и время'}
                defaultSortOrder='descend'
                sortDirections={['ascend', 'descend']}
                sorter={(a: FinanceTableProps, b: FinanceTableProps) =>
                    dayjs(a.buy_date).valueOf() - dayjs(b.buy_date).valueOf()
                }
                render={payment =>
                    dayjs(payment.buy_date).format('MM.DD.YY, HH:mm')
                }
            />
            <Table.Column
                sortDirections={['ascend', 'descend']}
                title='Сумма'
                sorter={(a: FinanceTableProps, b: FinanceTableProps) =>
                    a.amount - b.amount
                }
                render={payment => `${currencyFormat(payment.amount)}`}
            />
            <Table.Column title={'Тип'} dataIndex={'type'} />
            <Table.Column title={'Назначение'} dataIndex={'payable_title'} />
            <Table.Column
                title={
                    <TableFilter<string>
                        title='Имя'
                        onChange={first_name => {
                            onFiltersUpdate({ first_name });
                        }}
                        value={tableFilters.first_name}
                    >
                        <TableFilter.Text />
                    </TableFilter>
                }
                render={payment => (
                    <Space>
                        <Avatar src={payment.photo_url} />
                        {payment.first_name}
                    </Space>
                )}
            />
            <Table.Column
                title={
                    <TableFilter<string>
                        title='Юзернейм'
                        onChange={user_name => {
                            onFiltersUpdate({ user_name });
                        }}
                        value={tableFilters.user_name}
                    >
                        <TableFilter.Text />
                    </TableFilter>
                }
                render={payment =>
                    payment.user_name && (
                        <Link
                            target='_blank'
                            to={`https://t.me/${payment.user_name}`}
                        >
                            @{payment.user_name}
                        </Link>
                    )
                }
            />
            <Table.Column
                title={
                    <TableFilter<string>
                        title='Почта'
                        onChange={email => {
                            onFiltersUpdate({ email });
                        }}
                        value={tableFilters.email}
                    >
                        <TableFilter.Text />
                    </TableFilter>
                }
                dataIndex={'email'}
            />
        </Table>
    );
};
